module.exports = __webpack_public_path__ + "static/media/Corporate Account Manager  Corporate Salary - KMB.16ac8198.pdf";